<div class="content">
  <button
    mat-mini-fab
    class="add-btn"
    *ngIf="canEdit && selected == Tabs.iCase"
  >
    <mat-icon (click)="addFile()">add</mat-icon>
  </button>
  <div class="historial_header">
    <div
      class="item"
      [ngClass]="{ selected: selected == Tabs.iCase }"
      (click)="selected = Tabs.iCase"
    >
      <p>{{ Tabs.iCase }}</p>
    </div>
    <div
      class="item"
      [ngClass]="{ selected: selected == Tabs.task }"
      (click)="selected = Tabs.task"
    >
      <p>{{ Tabs.task }}</p>
    </div>
  </div>
  <div *ngIf="selected == Tabs.iCase">
    <file-item
      *ngFor="let file of files"
      [file]="file"
      [case]="file.case"
      (deleteFile)="delete($event)"
    ></file-item>
  </div>
  <div *ngIf="selected == Tabs.task">
    <div *ngFor="let task of tasks">
      <p class="titleTask">{{ task.title }}</p>
      <file-item-task
        *ngFor="let file of task.files"
        [file]="file"
        [case]="task.case"
        (deleteFile)="deleteFileTask($event)"
      ></file-item-task>
      <div class="divisior"></div>
    </div>
  </div>
</div>
